// extracted by mini-css-extract-plugin
export var select = "_qx-0";